module.exports = __webpack_public_path__ + "img/bee__2.dfb5b388.svg";